// extracted by mini-css-extract-plugin
export default {"customerDropdown":"Customer_customerDropdown__Y616U","customerOptions":"Customer_customerOptions__TtSPH"};